<template>
  <div>
    <editor ref="editor" v-model="content" :init="editorConfig" @input="updateContent" />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { UploadFile } from '@/api/_user';
export default {
  name: 'TinymceEditor',
  components: {
    Editor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    // 你可以根据需要添加更多自定义属性
  },
  data() {
    return {
      content: this.value,
      editorConfig: {
        language: 'zh_CN',
        height: 240,
        convert_urls: false,
        plugins: ['advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount'],
        toolbar: ['searchreplace fontsizeselect bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample', 'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen'],
        fontsize_formats: '12px 14px 16px 18px 24px 36px 48px 56px',
        file_picker_types: 'image video',
        images_upload_handler: (blobInfo, success, failure) => {
          const formData = new FormData()
          formData.append('file', blobInfo.blob())
          UploadFile(formData).then(res => {
            success(res.data)
          }).catch(() => {
            failure('上传失败，请重新上传')
          })
        },
        file_picker_callback: (callback, value, meta) => {
          // 这里可以触发一个文件选择对话框，或者使用其他方式获取文件
          // 然后调用callback函数，传入文件的blob对象或其他所需数据
          // 例如，使用一个隐藏的<input type="file">来触发文件选择
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('multiple', 'multiple');
          // input.setAttribute('accept', 'video/*'); // 只允许选择视频文件
          input.onchange = async (event) => {
            const files = Array.from(input.files);
            let that = this;
            const imagePromises = files.map(file => this.handleImageUpload(file));
            try {
              const imageUrls = await Promise.all(imagePromises);
              let htmlContent = ''
              imageUrls.forEach(item => {
                if (item.type === 'video/mp4') {
                  htmlContent += `<video width="300" height="150" controls>
                    <source src="${item.url}" type="video/mp4">
                    您的浏览器不支持 HTML5 视频标签。
                </video>`;
                } else {
                  htmlContent += `<img src="${item.url}" alt="">`;
                }
              })
              // 构建 HTML 字符串，每个 URL 对应一个 <img> 标签
              // const htmlContent = imageUrls.map(url => `<img src="${url}" alt="">`).join('');

              // 将 HTML 内容插入到 TinyMCE 编辑器中
              if (this.$refs.editor && this.$refs.editor.editor) {
                this.$refs.editor.editor.insertContent(htmlContent);
              }
            } catch (error) {
              console.error('Error uploading images:', error);
            }
          };
          input.click();
        },

      }
    };
  },
  watch: {
    // 监听外部传入的值变化，并更新内部数据
    value(newValue) {
      const normalizedValue = newValue || '';
      if (this.content !== normalizedValue) {
        this.content = normalizedValue;
        // 如果编辑器已初始化，同步更新编辑器内容
        this.$nextTick(() => {
          if (this.$refs.editor && this.$refs.editor.editor) {
            const editor = this.$refs.editor.editor;
            const currentContent = editor.getContent();
            if (currentContent !== normalizedValue) {
              editor.setContent(normalizedValue);
            }
          }
        });
      }
    }
  },
  methods: {
    handleImageUpload(file) {
      console.log(file)
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          // 这里你可以直接将 Base64 编码的图片插入
          // 或者将图片上传到服务器，然后使用返回的 URL
          // resolve(event.target.result);
          const formData = new FormData()
          formData.append('file', file)
          UploadFile(formData).then(res => {
            resolve({ url: res.data, type: file.type });
          }).catch(() => {

          })
        };
        reader.onerror = (error) => {
          reject(error);
        };
        reader.readAsDataURL(file);
      });
    },

    // 当编辑器内容变化时，更新外部传入的值
    updateContent(newContent) {
      this.$emit('input', newContent);
    },

  }
};
</script>

<style scoped>
/* 你可以在这里添加组件的样式 */
</style>
